
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar } from "lucide-react";
import { UserMenu } from "@/components/UserMenu";
import { useNavigate } from "react-router-dom";

interface GameHeaderProps {
  isDaily?: boolean;
}

export const GameHeader = ({ isDaily = false }: GameHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className="w-full border-b border-border fixed top-0 left-0 right-0 z-50 bg-background">
      <div className="container mx-auto py-4 px-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            onClick={() => navigate("/")}
            className="text-muted-foreground hover:text-foreground"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Home
          </Button>
          {isDaily && (
            <div className="px-2 py-1 bg-secondary text-secondary-foreground text-xs rounded-full flex items-center">
              <Calendar className="w-3 h-3 mr-1" />
              Daily Challenge
            </div>
          )}
        </div>
        <UserMenu />
      </div>
    </header>
  );
};
